import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FoodEntryItem, NewFoodEvent } from '../provision.component';

@Component({
    selector: 'app-food',
    templateUrl: './food.component.html',
    styleUrls: ['../sub-panel.scss'],
    standalone: false
})
export class FoodComponent {

  @Input()
  foods: FoodEntryItem[]

  @Output()
  delete = new EventEmitter<string>()

  @Output()
  save = new EventEmitter<NewFoodEvent>()

  foodForm = new UntypedFormGroup({
    date: new UntypedFormControl(null, Validators.required),
    foodName: new UntypedFormControl(null, Validators.required),
    foodPortion: new UntypedFormControl(null, [Validators.min(0)]),
    dogWeight: new UntypedFormControl(null, [Validators.min(0), Validators.max(100)]),
    comment: new UntypedFormControl(null)
  })

  showFoodForm = false

  addNewFood() {
    if (!this.showFoodForm) {
      this.showFoodForm = true
      this.foodForm.reset()
    }
  }

  clearNewFood() {
    this.showFoodForm = false
  }

  removeFood(docId: string) {
    if  (confirm('Biztos szeretné törölni ezt az étrendet?')) {
      this.delete.emit(docId)
    }
  }

  saveFood() {
    if (this.foodForm.valid) {
      const data = this.foodForm.value
      console.log('form data', data)
      this.save.emit({
        date: data.date.toDate(),
        dogWeight: data.dogWeight,
        foodName: data.foodName,
        foodPortion: data.foodPortion,
        comment: data.comment
      })
      this.clearNewFood()
    }
  }

}
